import SidePanel from '../SidePanel.jsx';
import PaymentForm from '../payments/PaymentForm.jsx';
import { formatDateTime } from '../../lib/DateTime.js';
import { useEffect, useState } from 'react';
import MoneyInput from '../MoneyInput.jsx';
import { formatCurrency } from '../../lib/CurrencyHelpers.js';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import Modal from '../Modal';
import AdminPaymentPanel from '../payments/AdminPaymentPanel.jsx';

const EventPaymentPanel = ({
    isOpen,
    onClose,
    event,
    totalPaid,
    totalPrice,
    refetch,
}) => {
    return (
        <AdminPaymentPanel
            key={event?.id}
            isOpen={isOpen}
            onClose={onClose}
            onSave={refetch}
            objectId={event.id}
            objectType="bookingevent"
            totalPrice={totalPrice}
            totalPaid={totalPaid}
        />
    );
};

export default EventPaymentPanel;
